/* eslint-disable no-case-declarations */
import { maturityValueGetter } from './maturity-getter';
import {
  BasicSeries,
  InterestType,
  SecurityType
} from '../../../types/deal.types';
import { DealsSeries } from '../../../helpers/deals/series';
import { OptionsType } from '../../../helpers/issue/maturity';
import { isDefined } from '../../../utils/utils';
import { ValueGetterParamsDealVersion } from './value-getters.interface';

export function dealTypeValueGetter(
  node: ValueGetterParamsDealVersion
): string[] | undefined {
  // Handle null or undefined values
  if (!isDefined(node.data)) {
    return [];
  }
  if (node.data.series) {
    return node.data.series.reduce((acc: string[], series: BasicSeries) => {
      const values: string[] = getValues(series, node);

      values.forEach((value: string) => {
        if (acc.indexOf(value) === -1) {
          acc.push(value);
        }
      });

      if (acc.length === 0) {
        acc.push(OptionsType.Blank);
      }

      return acc;
    }, []);
  } else {
    return [];
  }
}

function getValues(series, node) {
  let values: string[] = [];

  switch (series.interestType) {
    case InterestType.floatingRate:
      values.push('FRN');
      break;
    case InterestType.variableRate:
      values.push('VR');
      break;
    default:
      const maturitySecurityTypes: SecurityType[] = maturityValueGetter(
        series.id,
        'securityType'
      )(node);

      const seriesSecurityTypes = series.securityTypes || [];
      const securityTypes: SecurityType[] = (maturitySecurityTypes.length > 0
        ? maturitySecurityTypes
        : seriesSecurityTypes
      ).reduce((innerAcc: SecurityType[], secType: SecurityType) => {
        const value: SecurityType = DealsSeries.getSecurityType(secType);
        if (innerAcc.indexOf(value) === -1) {
          innerAcc.push(value);
        }
        return innerAcc;
      }, []);

      values = values.concat(securityTypes);
      break;
  }

  return values;
}
